import { graphql } from '../gql';

export const getVendorMenuTemplate = graphql(`
  query GetVendorMenuTemplate($input: GetVendorMenuTemplate!, $first: Int, $skip: Int) {
    getVendorMenuTemplate(input: $input) {
      error {
        code
        message
      }
      menuTemplate {
        id
        name
        productType
        state
        mealPeriods
        recentlyUpdated
        startDate
        endDate
        updatedAt
        ... on CateringVendorMenuTemplate {
          pricingType
          menuLevelPriceCents
        }
        categories {
          id
          name
          position
        }
        items(first: $first, skip: $skip) {
          totalCount
          currentPage
          nodes {
            id
            namePublic
            nameForVendor
            description
            dietaryRestrictions
            primaryImageUrl
            images
            preTaxPriceCents
            ... on CateringVendorMenuItem {
              perPersonUpchargeCents
            }
            category {
              id
              name
              position
            }
            optionGroups {
              id
              namePublic
              nameForVendor
              minSelections
              maxSelections
              includedSelections
              options {
                id
                namePublic
                nameForVendor
                preTaxPriceCents
              }
            }
          }
        }
      }
    }
  }
`);
